// Assets e links fixos por matéria, indexados pelo nome do veículo; os textos
// (título/resumo) vêm das traduções. Os logos vêm dos próprios veículos em
// versões de cor diferentes (branco, laranja, preto), então são normalizados
// para preto no CSS via `brightness-0` — igual ao tratamento da barra de logos
// de clientes.
export const PRESS_ARTICLES: Record<
  string,
  {
    url: string;
    logo: string;
    // Tamanho intrínseco do arquivo: vai no width/height do <img> só para o
    // navegador reservar a proporção antes de carregar (o CSS define a altura).
    logoWidth: number;
    logoHeight: number;
    logoClassName: string;
  }
> = {
  PEGN: {
    url: "https://revistapegn.globo.com/startups/noticia/2026/08/eles-fundaram-uma-startup-que-automatiza-cobranca-de-crediario-do-varejo-e-ja-recuperaram-r-394-milhoes.ghtml",
    logo: "/landing-page/press/pegn-logo.png",
    logoWidth: 1200,
    logoHeight: 618,
    logoClassName: "h-11 sm:h-12",
  },
  "Novo Varejo": {
    url: "https://novovarejo.com.br/fintech-fidexa-de-cobranca-no-varejo-atrai-empresario-que-levantou-us-130-milhoes-em-rodadas-internacionais/",
    logo: "/landing-page/press/novovarejo-logo.png",
    logoWidth: 1600,
    logoHeight: 89,
    logoClassName: "h-4 sm:h-5",
  },
  "Portal ERP": {
    url: "https://portalerp.com/br/artigo/fidexa-integra-ia-e-whatsapp-ao-erp-da-totvs-linx-para-automatizar-cobranca-no-varejo",
    logo: "/landing-page/press/portalerp-logo.png",
    logoWidth: 701,
    logoHeight: 417,
    logoClassName: "h-10 sm:h-11",
  },
  NOVAREJO: {
    url: "https://portalnovarejo.com.br/noticias/fidexa-a-startup-que-ajuda-lojas-a-recuperar-dividas-com-whatsapp/",
    logo: "/landing-page/press/novarejo-logo.png",
    logoWidth: 223,
    logoHeight: 148,
    logoClassName: "h-11 sm:h-12",
  },
  Baguete: {
    url: "https://www.baguete.com.br/noticias/fidexa-vai-atras-de-pequenos-devedores",
    logo: "/landing-page/press/baguete-logo.svg",
    logoWidth: 2755,
    logoHeight: 774,
    logoClassName: "h-7 sm:h-8",
  },
};

// Veículo usado na pílula de destaque: é a matéria que origina o número de
// R$ 39,4 milhões exibido logo acima dela.
export const PRESS_HIGHLIGHT_OUTLET = "PEGN";
